export class InsuredTripSummary {
  dateBegin: string;
  dateEnd: string;
}
